/* eslint-disable complexity */
import { TERMINE_TERMIN_DELETE } from '@/domain/termine/hooks/graphql/mutation';
import {
  DeleteTerminMutation,
  DeleteTerminMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import * as Sentry from '@sentry/react';

export type DeleteTerminResult = {
  error: { message: string } | null;
  errorType: string | null;
};

export function useDeleteTermin(): {
  deleteTermin: (terminId: string) => Promise<DeleteTerminResult>;
  response: DeleteTerminMutation['termine_terminDelete'] | undefined;
  loading: boolean;
} {
  const [mutate, { data, loading }] = useMutation<
    DeleteTerminMutation,
    DeleteTerminMutationVariables
  >(TERMINE_TERMIN_DELETE, {
    refetchQueries: [
      'GetTagesDaten',
      'GetTermineKalenderByStandortIdAndZeitraum',
    ],
    awaitRefetchQueries: true,
  });

  const deleteTermin = async (
    terminId: string,
  ): Promise<DeleteTerminResult> => {
    try {
      const result = await mutate({
        variables: {
          idTerminDefinitionen: terminId,
        },
      });
      const response = result.data?.termine_terminDelete;
      if (response?.result) {
        return { error: null, errorType: null };
      }

      const errorType = response?.error?.__typename ?? null;
      const message = response?.error?.message ?? null;
      return { error: message ? { message } : null, errorType };
    } catch (err) {
      Sentry.captureException(err);
      const message = err instanceof Error ? err.message : String(err);
      return { error: { message }, errorType: 'unexpected' };
    }
  };

  return { deleteTermin, response: data?.termine_terminDelete, loading };
}
